import Vue from "vue";
import VueRouter, { Route, NavigationGuardNext } from "vue-router";
import routes from "./routes";
import { Permission } from "@/permissions/types";
import { Dictionary } from "vue-router/types/router";

Vue.use(VueRouter);

const router: VueRouter = new VueRouter({
    mode: "history",
    routes
});

router.beforeEach(
    async (to: Route, from: Route, next: NavigationGuardNext<Vue>) => {
        let permissions: Permission[] = [];

        // procura a primeira rota que deu match que tenha o atributo permissions no meta
        to.matched.some(record => {
            if (record.meta.permissions) {
                permissions = record.meta.permissions as Permission[];
            }
            return record.meta.permissions;
        });

        if (permissions.length > 0) {
            let failedPermission: Permission | null = null;

            // verifica se todas as permissões passaram
            for (const permission of permissions) {
                if (!(await permission.hasPermission(to, from))) {
                    failedPermission = permission;
                    break;
                }
            }

            // em caso de falha, redireciona
            if (failedPermission !== null) {
                return next({
                    name: failedPermission.redirectRouteName,
                    params: {
                        message: failedPermission.message
                    },
                    query: failedPermission.query as Dictionary<string>
                });
            }
        }
        // vai para a rota de destino normalmente caso tenha permissão
        next();
    }
);

export default router;
